<div class="mat-dialog-wrapper">
  <mat-dialog-content>
    <div class="main-wrapper">
      <div class="sidenav-header">
        <h2>
          <span>{{ headerText }}</span>
        </h2>
      </div>
    </div>
    <div class="pb-5">
      <p class="m-0">{{ bodyText }}</p>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions class="justify-content-center border-none">
    <button
      class="action-button primary-button mr-1"
      mat-dialog-close
      type="button"
      mat-button
      disableRipple
      (click)="onYesClick()"
    >
      Yes
    </button>
    <button
      class="action-button secondary-button"
      mat-dialog-close
      type="button"
      mat-button
      disableRipple
      (click)="onNoClick()"
    >
      No
    </button>
  </mat-dialog-actions>
</div>
